<mat-progress-bar *ngIf="isLoadingKoovea" mode="indeterminate" color="primary"></mat-progress-bar>

<mat-table [dataSource]="dataSource" class="mat-elevation-z2 scansTable" matSort>
  <ng-container matColumnDef="code">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
    <mat-cell *matCellDef="let scan">
      <span *ngIf="scan.code">{{scan.code}}</span>
      <span *ngIf="!scan.code">{{scan.container.description}}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="productType">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Type de produit </mat-header-cell>
    <mat-cell *matCellDef="let scan"> {{scan.container.productType.name}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="description">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Description Container </mat-header-cell>
    <mat-cell *matCellDef="let scan"> {{scan.container.description}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="scannedOn">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Date d'encodage </mat-header-cell>
    <mat-cell *matCellDef="let scan"> {{scan.scannedOn | amDateFormat: 'DD/MM/YYYY HH:mm'}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="identifier">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Identifiant ID TAG </mat-header-cell>
    <mat-cell *matCellDef="let scan"> {{scan.container.identifier}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="tag">
    <mat-header-cell *matHeaderCellDef mat-sort-header> KooveaTag conteneur </mat-header-cell>
    <mat-cell *matCellDef="let scan">
      {{scan.container.tag}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Export</mat-header-cell>
    <mat-cell *matCellDef="let scan">
      <button mat-icon-button *ngIf="scan.container.tag" [disabled]="isLoadingKoovea" color="primary"
        matTooltip="Télécharger le fichier PDF Koovea du conteneur" (click)="downloadKooveaPDF(scan)">
        <mat-icon>picture_as_pdf</mat-icon>
      </button>

      <!-- <mat-spinner *ngIf="isLoadingKoovea" diameter="30" color="primary"></mat-spinner> -->
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
<mat-paginator [pageSize]="10" [length]="scans.length" showFirstLastButtons></mat-paginator>